/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  SacraRelayTarget,
  SacraRelayTargetInterface,
} from "../SacraRelayTarget";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "trustedForwarder_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ErrorF2",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value1_",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "value2_",
        type: "bool",
      },
    ],
    name: "f1",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "f1data",
    outputs: [
      {
        internalType: "uint256",
        name: "value1",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "value2",
        type: "bool",
      },
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value1_",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "value2_",
        type: "bool",
      },
    ],
    name: "fWithReturn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "funcRevert",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "funcRevertCustomError",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "funcRevertPanic",
    outputs: [],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "trustedForwarder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class SacraRelayTarget__factory {
  static readonly abi = _abi;
  static createInterface(): SacraRelayTargetInterface {
    return new Interface(_abi) as SacraRelayTargetInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): SacraRelayTarget {
    return new Contract(address, _abi, runner) as unknown as SacraRelayTarget;
  }
}
